import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Btn } from "./ui";

// Compact inner-page hero with breadcrumb, title, subtitle, optional image + CTAs.
export const PageHero = ({ crumb, eyebrow, title, subtitle, image, ctas = [] }) => (
  <section className="pt-[70px]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-10">
      <div className="bg-[#F5F5F5] rounded-[20px] overflow-hidden">
        <div className={`grid ${image ? "lg:grid-cols-2" : ""} items-center`}>
          <div className="p-8 sm:p-12 lg:p-14">
            <nav className="flex items-center gap-1.5 text-xs text-[#2D2D37]/50 mb-5" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-[#254369]">Home</Link>
              <ChevronRight size={13} />
              <span className="text-[#254369] font-medium">{crumb}</span>
            </nav>
            {eyebrow && (
              <p className="fade-up-1 text-[#C9A961] font-heading font-bold uppercase tracking-[0.18em] text-xs mb-4">
                {eyebrow}
              </p>
            )}
            <h1 className="fade-up-2 font-heading font-extrabold tracking-tight text-4xl sm:text-5xl leading-[1.06] text-[#2D2D37]">
              {title}
            </h1>
            {subtitle && (
              <p className="fade-up-3 mt-5 text-base sm:text-lg leading-relaxed text-[#2D2D37]/70 max-w-xl">
                {subtitle}
              </p>
            )}
            {ctas.length > 0 && (
              <div className="fade-up-4 mt-8 flex flex-wrap gap-3">
                {ctas.map((c, i) => (
                  <Btn key={i} href={c.href} variant={c.variant || "primary"} testid={c.testid} pill={c.pill}>
                    {c.label}
                  </Btn>
                ))}
              </div>
            )}
          </div>
          {image && (
            <div className="p-6 sm:p-8 lg:p-10">
              <img
                src={image}
                alt={title}
                className="w-full h-[240px] sm:h-[340px] lg:h-[400px] object-cover rounded-[20px] shadow-lg"
                loading="eager"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  </section>
);
